import { useTranslation } from 'react-i18next';

import { useAppSelector } from 'store/hooks';
import { RootState } from 'store';

import { Container, Label } from './PromoCodeTag.styles';

export const PromoCodeTag = () => {
	const { t } = useTranslation();
	const { isPunchup } = useAppSelector(({ auth }: RootState) => auth);

	return (
		<Container isPunchup={isPunchup}>
			<Label isPunchup={isPunchup}>{t('promoCodeApplied')}</Label>
		</Container>
	);
};
